<div fxFill fxLayout="column" fxLayoutAlign="start">
    <mat-toolbar color="primary" class="toolbar">
        <app-back-button color="secondary" [route]="['/home', 'perfil']"></app-back-button>
        <div>{{ "BILLING.TITLE" | translate }}</div>
    </mat-toolbar>
    <div class="menu" style="padding: 10px">
        <mat-form-field fxFill>
            <mat-label>Status</mat-label>
            <mat-select
                [id]="'select_profile_billing-Filters'"
                [multiple]="true"
                (selectionChange)="filterChanged($event)"
            >
                <mat-option value="Pending">
                    {{ "BILLING.STATUS.PENDING" | translate }}
                </mat-option>
                <mat-option value="Paid">
                    {{ "BILLING.STATUS.BILLED" | translate }}
                </mat-option>
                <mat-option value="ExternallyPaid">
                    {{ "BILLING.STATUS.EXTERNALLY_PAID" | translate }}
                </mat-option>
                <mat-option value="Canceled">
                    {{ "BILLING.STATUS.CANCELED" | translate }}
                </mat-option>
                <mat-option value="Expired">
                    {{ "BILLING.STATUS.EXPIRED" | translate }}
                </mat-option>
                <mat-option value="Review">
                    {{ "BILLING.STATUS.REVIEW" | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div fxLayout="column" fxLayoutAlign="stretch">
        <mat-card class="mat-elevation-z3" *ngFor="let bill of bills$ | async">
            <mat-card-header>
                <mat-card-title>
                    {{ "BILLING.STATUS." + showStatus(bill) | translate }}
                </mat-card-title>

                <mat-card-subtitle *ngIf="!bill.plan">
                    {{ bill.product?.name }}
                </mat-card-subtitle>

                <mat-card-subtitle *ngIf="bill.plan">
                    {{ bill.plan?.name }}
                </mat-card-subtitle>

                <mat-card-subtitle>
                    {{
                        ("BILLING." + (bill.paymentMethod === 'CreditCard' ? 'CREDIT_CARD' : 
                         bill.paymentMethod === 'BankSlip' ? 'BANK_SLIP' : 
                         bill.paymentMethod === 'Pix' ? 'PIX' : 
                         bill.paymentMethod === 'Coupon' ? 'COUPON' : 'BANK_SLIP')) | translate
                    }}
                </mat-card-subtitle>
                <mat-card-subtitle>
                    {{ bill.createdAt | amDateFormat: "DD/MM/YYYY" }}
                </mat-card-subtitle>
                <mat-card-subtitle> R$ {{ showMoney(bill.amount) }} </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content *ngIf="bill.status === 'Review'">
                <div class="review-note" style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px; padding: 12px; margin: 8px 0; color: #856404;">
                    <mat-icon style="vertical-align: middle; margin-right: 8px; color: #f39c12;">info</mat-icon>
                    {{ "BILLING.REVIEW_NOTE" | translate }}
                </div>
            </mat-card-content>

            <mat-card-actions align="end" *ngIf="bill.invoice?.status == 'Completed'">
                <button mat-raised-button (click)="downloadInvoice(bill.invoice.id)">
                    {{ "BILLING.INVOICE" | translate }}
                    <mat-icon>save_alt</mat-icon>
                </button>
            </mat-card-actions>
            <mat-card-actions align="end" *ngIf="bill.status === 'Pending' || bill.status === 'Review'">
                <button mat-icon-button (click)="openCancelBillDialog(bill)">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>
        <ghost-data [show]="loading">
            <mat-card class="mat-elevation-z3">
                <mat-card-header>
                    <mat-card-title>
                        <div class="loader"></div>
                        {{ "BILLING.LOADING" | translate }}
                    </mat-card-title>
                    <mat-card-subtitle>
                        <div class="loader"></div>
                        {{ "BILLING.LOADING" | translate }}
                    </mat-card-subtitle>
                    <mat-card-subtitle>
                        <div class="loader"></div>
                        {{ "BILLING.LOADING" | translate }}
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </ghost-data>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <button
            [id]="'button_teach-courses-questions-more_MostrarMais'"
            mat-flat-button
            color="primary"
            [class.spinner]="loading"
            [disabled]="!showMore"
            (click)="loadMore()"
        >
            {{ "BILLING.SHOW_MORE" | translate }}
        </button>
    </div>
</div>
